import PropTypes from 'prop-types'
import { useState } from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import { isEmpty, head } from 'lodash'

import { Card } from 'components'

import DialogDpoFantasy from './components/DialogDpoFantasy'
import constants from 'constants/index'

const InviteFantasyDpo = ({ refresh, outsourcedDpo }) => {
  const [openDialog, setOpenDialog] = useState(false)

  const handleOpenDialog = () => {
    setOpenDialog(true)
  }

  const activeFantasyDpos = outsourcedDpo?.fantasyDpos?.filter(
    (fantasyDpo) => fantasyDpo?.active,
  )

  const responsible = head(
    activeFantasyDpos?.filter(
      (fantasyDpo) =>
        fantasyDpo?.kind === constants.fantasyDpo.KIND_RESPONSIBLE,
    ),
  )

  const substitute = head(
    activeFantasyDpos?.filter(
      (fantasyDpo) => fantasyDpo?.kind === constants.fantasyDpo.KIND_SUBSTITUTE,
    ),
  )

  return (
    <Box mt={4}>
      <Card title="DPO Fantasia" paddingBottom={0}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="body1" color="textPrimary">
            {isEmpty(outsourcedDpo?.fantasyDpos) ? (
              <>
                Essa empresa não possui um <b>DPO Fantasia</b> registrado.
              </>
            ) : responsible?.active || substitute?.active ? (
              <>
                <b>{responsible?.name || substitute?.name}</b> está registrado
                como o DPO Fantasia dessa empresa.
              </>
            ) : (
              <>
                Essa empresa não possui um <b>DPO Fantasia</b> ativo.
              </>
            )}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenDialog}
          >
            {isEmpty(responsible)
              ? 'Adicionar DPO Fantasia'
              : 'Visualizar DPO Fantasia'}
          </Button>
        </Box>
      </Card>
      <DialogDpoFantasy
        refresh={refresh}
        open={openDialog}
        setOpen={setOpenDialog}
        outsourcedDpo={outsourcedDpo}
      />
    </Box>
  )
}

InviteFantasyDpo.propTypes = {
  refresh: PropTypes.func,
  outsourcedDpo: PropTypes.object,
}

InviteFantasyDpo.defaultProps = {
  refresh: () => {},
}

export default InviteFantasyDpo
